/**
 * Utilitário para identificar o contexto de uma URL e retornar a mensagem de erro apropriada
 * junto com um código de erro específico para cada URL
 */

import { DEFAULT_ERROR_CODE, DEFAULT_ERROR_MESSAGE, ERROR_CONTEXT_MAP } from "./errorMap";

// Interface para o retorno da função getErrorMessageByUrl
export interface ErrorResponse {
	errorMessage: string;
	code: string;
}

/**
 * Identifica o contexto de uma URL e retorna a mensagem de erro apropriada e o código
 *
 * @param url A URL a ser analisada
 * @returns Um objeto com a mensagem de erro e o código correspondente ao contexto da URL
 */
export const getErrorMessageByUrl = (url: string): ErrorResponse => {
	// Verifica cada contexto para encontrar correspondência com a URL
	for (const [, { patterns, errorMessage }] of Object.entries(ERROR_CONTEXT_MAP)) {
		// Para cada padrão de URL neste contexto
		for (const pattern of patterns) {
			// Se a URL contém este padrão específico
			if (url.includes(pattern.url)) {
				return {
					errorMessage,
					code: pattern.code,
				};
			}
		}
	}

	// Retorna a mensagem de erro padrão e código se nenhum contexto foi identificado
	return {
		errorMessage: DEFAULT_ERROR_MESSAGE,
		code: DEFAULT_ERROR_CODE,
	};
};

